import { configurationQuery } from './configurationQuery'

const configuration = async () => configurationQuery({})

export default configuration
